import React from 'react';
import TheftRecoveryActiveCell from "./TheftRecoveryActiveCell.js";
import SwatchAndColor from "../../../views/color/SwatchAndColor.js";
export default {
  install: molten => {
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'assetLocators',
      attrName: 'assetLocators.theftRecoveryActive',
      renderer: (data, props, context) => /*#__PURE__*/React.createElement(TheftRecoveryActiveCell, {
        value: data.value
      })
    });
    molten.addPlugin('AttributeCellRenderer', {
      objectType: 'assetLocators',
      attrName: 'assetLocators.swatchAndColor',
      renderer: (data, props, context) => {
        if (data.value) {
          return /*#__PURE__*/React.createElement(SwatchAndColor, {
            value: data.value,
            object: Array.isArray(context.target) ? context.target[0] : null,
            style: {
              weight: 150,
              height: 45,
              paddingLeft: 10
            },
            swatchStyle: {},
            variant: 'columnValue'
          });
        }
        return null;
      }
    });
  }
};